import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const cutoutPropertiesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Cutout Properties',
		onClick: ({ context, controller }): void => {
			controller.publishShowProperties('cutout', context.id);
		},
		isVisible: ({ refMap }): boolean => {
			// const { ui } = appState;
			// const refEntry = controller?.kitchen?.getReferenceMap(ui.pointer.context.ref.id);

			// Don't continue if we are not dealing with a PanelItem
			// if (refEntry.type !== ReferenceEntryType.PanelItem) return false;

			const categoryKey = refMap?.panelItem?.item.category?.key;
			return categoryKey === 'cutout' || categoryKey === 'hole';
		}
	};
};
